import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect'
import { routerActions } from 'react-router-redux';
import { accountRoles } from '../../../common/enums';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../api';
import { selectAccount } from '../ducks';

export default connectedRouterRedirect({
  authenticatedSelector: state => (selectAccount(state) && selectAccount(state).role === accountRoles.CALL_CENTRUM || selectAccount(state) && selectAccount(state).role === accountRoles.ADMINISTRATOR),
  authenticatingSelector: state => selectIsInProgress(state, apiCallIds.LOGIN),
  redirectPath: state => (selectAccount(state) ? '/' : '/auth/login'),
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'IsCallCentrum',
});



// WEBPACK FOOTER //
// ./src/features/auth/utils/IsCallCentrum.js